import React from 'react';

import Box from '../Box';
import { LinearGradientProps } from './type';

const LinearGradient: React.FC<React.PropsWithChildren<LinearGradientProps>> = (props) => {
  return (
    <Box className={props.className} style={{ backgroundImage: props.css }}>
      {props.children}
    </Box>
  );
};

export default React.memo(LinearGradient);
